// extracted by mini-css-extract-plugin
export default {"middle_box":"expenseStatus_middle_box__olCqu","bar_wrapper":"expenseStatus_bar_wrapper__PuYVN","bar_progress":"expenseStatus_bar_progress__7gYeY"};